import { message } from 'antd'
import { EFaxQuality } from '../utils/enum'
import { post } from './base'

const faxApi = {
  uploadFile({ file }, noMsg) {
    const formData = new FormData()
    formData.append('file', file)

    return post('api/fax/uploadFileFormData', formData, { noMsg })
  },

  uploadFiles({ files }) {
    const allUploadPromise = files.map((file) => {
      return this.uploadFile({ file })
    })
    return Promise.all(allUploadPromise).then((datas) => {
      return datas.map((data) => data.fileId)
    })
  },

  uploadLocalFiles({ files }) {
    const allUploadPromise = files.map((file) => {
      return this.uploadFile({ file }, true)
    })
    return Promise.allSettled(allUploadPromise).then((res) => {
      const idList = []
      res.forEach((it, index) => {
        if (it.status === 'fulfilled') {
          const uuid = files[index].uuid
          // const fileId = it.value.fileId
          // const url = it.value.url
          idList.push({ [uuid]: it.value })
        } else {
          // message.error(`${files[index].name || files[index].fileName} ${it.reason.message}`)
          const err = it.reason.message.includes('timeout') ? 'The file upload process timed out. Please try again.' : it.reason.message
          message.error(err)
        }
      })

      return idList
    })
  },

  thirdUploadFile(files) {
    return post('api/fax/thirdUploadFile', { files })
  },

  // sendFax ({
  //   fileIds = [],
  //   fromPhone = '',
  //   texts = [],
  //   toPhones = [],
  // }) {
  //   return post('api/fax/sendfax', {
  //     files: fileIds,
  //     fromPhone,
  //     texts,
  //     toPhones,
  //   });
  // },

  sendFax({
    fileIds = [],
    fromPhone = '',
    texts = [],
    toPhones = [],

    coverFilePath = '',
    coverId = '',
    message = '',

    recipientEmail = '',
    recipientName = '',
    recipientNumber = '',

    senderEmail = '',
    senderName = '',
    senderNumber = '',

    quality = EFaxQuality.Standard,

    sendFaxSchduleTime = 0,
    repeat = 0,
    repeatPriod = 0,
  }) {
    return post('api/fax/sendfax', {
      files: fileIds,
      fromPhone,
      texts,
      toPhones,

      coverFilePath,
      coverId,
      message,

      recipientEmail,
      recipientName,
      recipientNumber,

      senderEmail,
      senderName,
      senderNumber,
      quality,

      sendFaxSchduleTime,
      repeat,
      repeatPriod,
    })
  },
  // 手动重发
  reSend(faxLogId) {
    return post('api/fax/reSend', { faxLogId })
  },

  //设置备注
  faxNote(faxLogId, description) {
    return post('api/fax/setFaxDescription', { faxLogId, description })
  },
}

export default faxApi
